export function Throttle(duration = 0, mode = 'timestamp') {
    return (target, name, descriptor) => {
        const fn = descriptor.value;
        if (typeof fn !== 'function') {
            throw new Error('[Throttle]: support to decorate functions only.');
        }
        let timer = null;
        let pre = 0;
        if (mode === 'timestamp') {
            descriptor.value = function (...args) {
                const now = Date.now();
                if (now - pre > duration) {
                    pre = now;
                    fn.apply(this, args);
                }
            };
        }
        else if (mode === 'timer') {
            descriptor.value = function (...args) {
                if (!timer) {
                    timer = setTimeout(() => {
                        timer = null;
                        fn.apply(this, args);
                    }, duration);
                }
            };
        }
        else {
            throw new Error('[Throttle]: unknown mode.');
        }
        return descriptor;
    };
}
